import { createSlice } from '@reduxjs/toolkit';

import {
    BULK_UPDATE_ITEMS,
    BULK_UPDATE_ITEMS_FAILURE,
    BULK_UPDATE_ITEMS_SUCCESS,
    FETCH_FILTER_PROJECTS,
    FETCH_FILTER_PROJECTS_FAILURE,
    FETCH_FILTER_PROJECTS_SUCCESS,
    FETCH_STATUS_PROJECT,
    FETCH_STATUS_PROJECT_FAILURE,
    FETCH_STATUS_PROJECT_SUCCESS,
    INITIALIZE,
    INITIALIZE_FAILURE,
    INITIALIZE_SUCCESS,
    RESET,
    SAVE_PROJECT,
    SAVE_PROJECT_FAILURE,
    SAVE_PROJECT_SUCCESS,
    SHOW_EMPTY_STATE,
    UPDATE_ITEMS_SUCCESS,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    bulkUpdateItems: {
        data: [],
        errors: [],
        isFetching: false,
    },
    projects: {
        data: {
            data: [],
            pagination: null,
        },
        errors: [],
        isFetching: false,
    },
    isInitializing: false,
    saveProject: {
        errors: [],
        isSaving: false,
    },
    showEmptyState: {
        status: 'active',
        show: false,
    },
};

const projectsSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [BULK_UPDATE_ITEMS]: (state) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                errors: [],
                isFetching: true,
            };
        },
        [BULK_UPDATE_ITEMS_FAILURE]: (state, action) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                errors: action.payload,
                isFetching: false,
            };
        },
        [BULK_UPDATE_ITEMS_SUCCESS]: (state, action) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_FILTER_PROJECTS]: (state) => {
            state.projects = {
                ...state.projects,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_FILTER_PROJECTS_FAILURE]: (state, action) => {
            state.projects = {
                ...state.projects,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_FILTER_PROJECTS_SUCCESS]: (state, action) => {
            state.projects = {
                ...state.projects,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_STATUS_PROJECT]: (state) => {
            state.updateStatusProject.isFetching = true;
        },
        [FETCH_STATUS_PROJECT_FAILURE]: (state, action) => {
            state.updateStatusProject = {
                ...state.updateStatusProject,
                error: action.payload,
                isFetching: false,
            };
        },
        [FETCH_STATUS_PROJECT_SUCCESS]: (state, action) => {
            state.updateStatusProject = {
                ...state.updateStatusProject,
                data: action.payload,
                isEmpty: action.payload.length === 0,
                isFetching: false,
            };
        },
        [INITIALIZE]: (state) => {
            state.isInitializing = true;
        },
        [INITIALIZE_FAILURE]: (state) => {
            state.isInitializing = false;
        },
        [INITIALIZE_SUCCESS]: (state) => {
            state.isInitializing = false;
        },
        [RESET]: () => INITIAL_STATE,
        [SAVE_PROJECT]: (state) => {
            state.saveProject = {
                ...state.saveProject,
                errors: [],
                isSaving: true,
            };
        },
        [SAVE_PROJECT_FAILURE]: (state, action) => {
            state.saveProject = {
                ...state.saveProject,
                errors: action.payload,
                isSaving: false,
            };
        },
        [SAVE_PROJECT_SUCCESS]: (state, action) => {
            state.saveProject = {
                ...state.saveProject,
                data: action.payload,
                isSaving: false,
            };
        },
        [SHOW_EMPTY_STATE]: (state, action) => {
            state.showEmptyState = action.payload;
        },
        [UPDATE_ITEMS_SUCCESS]: (state, action) => {
            state.projects.data.data = action.payload;
        },
    },
});

export const projectsActions = projectsSlice.actions;

export default projectsSlice.reducer;
